// 1) jQuery on window
import $ from 'jquery';
window.$ = window.jQuery = $;

// 2) what-input before Foundation
import 'what-input';

// 3) Foundation core (named export)
import { Foundation } from 'foundation-sites/js/foundation.core';

// 4) Utilities: import, attach to Foundation, and init where needed
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
Foundation.Keyboard = Keyboard;

import { Touch } from 'foundation-sites/js/foundation.util.touch';
Foundation.Touch = Touch;

import { Nest } from 'foundation-sites/js/foundation.util.nest';
Foundation.Nest = Nest;

import { Box } from 'foundation-sites/js/foundation.util.box';
Foundation.Box = Box;

import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
Foundation.MediaQuery = MediaQuery;
Foundation.MediaQuery._init(); // important for responsive components

import { Motion, Move } from 'foundation-sites/js/foundation.util.motion';
Foundation.Motion = Motion;
Foundation.Move   = Move;

import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
Triggers.init($, Foundation); // wires data-* triggers to jQuery

// 5) Create the jQuery bridge
Foundation.addToJquery($);

// 6) Components you actually use
import { Tabs } from 'foundation-sites/js/foundation.tabs';
import { Accordion } from 'foundation-sites/js/foundation.accordion';
import { ResponsiveAccordionTabs } from 'foundation-sites/js/foundation.responsiveAccordionTabs';

// --- Added to match your “make sure all these are added” list ---
import { Reveal } from 'foundation-sites/js/foundation.reveal';
import { AccordionMenu } from 'foundation-sites/js/foundation.accordionMenu';
import { Tooltip } from 'foundation-sites/js/foundation.tooltip';
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';
import { Drilldown } from 'foundation-sites/js/foundation.drilldown';
import { Sticky } from 'foundation-sites/js/foundation.sticky';
import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
import { Orbit } from 'foundation-sites/js/foundation.orbit';
// ---------------------------------------------------------------

// 7) Register components with Foundation
Foundation.plugin(Tabs, 'Tabs');
Foundation.plugin(Accordion, 'Accordion');
Foundation.plugin(ResponsiveAccordionTabs, 'ResponsiveAccordionTabs');

// --- Register added components ---
Foundation.plugin(Reveal, 'Reveal');
Foundation.plugin(AccordionMenu, 'AccordionMenu');
Foundation.plugin(Tooltip, 'Tooltip');
Foundation.plugin(OffCanvas, 'OffCanvas');
Foundation.plugin(Drilldown, 'Drilldown');
Foundation.plugin(Sticky, 'Sticky');
Foundation.plugin(DropdownMenu, 'DropdownMenu');
Foundation.plugin(Dropdown, 'Dropdown');
Foundation.plugin(Orbit, 'Orbit');
// ---------------------------------

// 8) Init after DOM ready
$(function () {
  // sanity logs
  console.log('Foundation exists:', !!window.Foundation);
  console.log('jQuery bridge exists:', typeof $.fn.foundation === 'function');
  console.log('Registered plugins:', Object.keys(window.Foundation?._plugins || {}));

  $(document).foundation();
});

// make tabs vertical only when viewport is large+
function setTabsOrientation() {
  var $tabs = $('#profile-tabs');
  var $panels = $('[data-tabs-content="profile-tabs"]');
  if (Foundation.MediaQuery.atLeast('large')) {
    $tabs.addClass('vertical');
    $panels.addClass('vertical');
  } else {
    $tabs.removeClass('vertical');
    $panels.removeClass('vertical');
  }
}

$(function () {
  $(document).foundation();
  setTabsOrientation();
  $(window).on('changed.zf.mediaquery', setTabsOrientation);
});

// 9) Your modules
import './modules/AjaxPosts';
import './modules/SmoothScroll';
import './modules/ObjectFitIE';
import './modules/Animation';
import './modules/Splide';
import './modules/BarristersSearch.js';
import './modules/GravityFormsEdit.js';